import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { DesignSettingsChangesSections } from './types';

export function designSettingsFieldsChangedEvent({
  section,
  changedFields = [],
}: {
  section: DesignSettingsChangesSections;
  changedFields?: string[];
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.DESIGN_SETTINGS_CHANGED_FIELDS,
  };

  pushToDataLayer({
    ...eventAttributes,
    section,
    changed_fields: changedFields.length > 0 ? changedFields : undefined,
  });
}
